import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Image } from '../../../components/Image/GalleryOverlay/components/Image.js';
import { List } from '../../../components/Image/GalleryOverlay/components/List.js';
import { Tile } from '../../../components/Image/GalleryOverlay/components/Tile.js';
export const GalleryOverlay = ({
  images,
  activeImage,
  onClickImage
}) => {
  const refs = useRef([]);
  const handleClickImage = imageIndex => () => {
    onClickImage(imageIndex);
  };
  useEffect(() => {
    if (!activeImage || !refs?.current) {
      return;
    }
    refs.current[activeImage].scrollIntoView();
  }, [activeImage]);
  useEffect(() => {
    if (activeImage && activeImage > images.length - 1) {
      onClickImage(0);
    }
  }, [activeImage, images.length, onClickImage]);
  return _jsx(List, {
    children: images.map((image, index) => {
      return _jsx(Tile, {
        ref: el => refs.current = [...refs.current, el],
        active: index === activeImage,
        children: _jsx(Image, {
          src: image,
          onClick: handleClickImage(index)
        })
      }, image);
    })
  });
};